import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop component - resets scroll position on route change
 * Place this inside BrowserRouter to ensure scroll resets on navigation
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
